import classNames from 'classnames';
import { FC } from 'react';
import styles from './button.module.scss';
import { ButtonProps } from './button.props';

/**
 * Renders Button
 */
const Button: FC<ButtonProps> = ({
  className,
  color,
  preventDefault,
  link,
  hexColor,
  textHexColor,
  datapopupaction,
  disabled,
  children,
  width,
  padding,
  dataName,
  dataLevel,
  loading,
  ...props
}) => (
  <>
    {!!link ? (
      <a
        href={`${link}`}
        target='_blank'
        onClick={event => {
          if (preventDefault) {
            event.preventDefault();
          }
        }}
      >
        <button
          data-level={dataLevel}
          data-name={dataName}
          style={{
            backgroundColor: hexColor,
            color: textHexColor,
            width: width,
            padding: padding
          }}
          className={classNames(
            styles.button,
            { [styles[color]]: !hexColor },
            className,
            {
              [styles.disabled]: disabled
            }
          )}
          disabled={disabled}
          data-popup-action={datapopupaction}
          {...props}
        >
          {disabled && loading ? (
            <div className={styles.loader}></div>
          ) : (
            children
          )}
        </button>
      </a>
    ) : (
      <button
        data-level={dataLevel}
        data-name={dataName}
        data-popup-action={datapopupaction}
        style={{
          backgroundColor: hexColor,
          color: textHexColor,
          width: width,
          padding: padding
        }}
        className={classNames(
          styles.button,
          { [styles[color]]: !hexColor },
          className,
          {
            [styles.disabled]: disabled
          }
        )}
        disabled={disabled}
        {...props}
      >
        {disabled && loading ? <div className={styles.loader}></div> : children}
      </button>
    )}
  </>
);

/**
 * Button Default Props
 */
Button.defaultProps = {
  color: 'primary'
};

export { Button };
